import { router } from 'expo-router';
import { useEffect } from 'react';

import { useToast } from '@/src/components/Toast';

import { subscribeToForegroundPushMessages } from './web-push-service';

export function ForegroundPushHandler() {
  const { showToast } = useToast();

  useEffect(() => {
    let unsubscribe: (() => void) | null = null;
    let mounted = true;

    void subscribeToForegroundPushMessages((message) => {
      showToast({
        message: message.body,
        onPress: () => {
          router.push(message.url);
        },
        title: message.title,
        variant: 'info',
      });
    }).then((nextUnsubscribe) => {
      if (!mounted) {
        nextUnsubscribe?.();
        return;
      }

      unsubscribe = nextUnsubscribe;
    });

    return () => {
      mounted = false;
      unsubscribe?.();
    };
  }, [showToast]);

  return null;
}
